import React from "react";
import styled from "@emotion/styled";

interface Props {
  hasLine?: boolean;
}

const SubscriptionFooter: React.FunctionComponent<Props> = ({ hasLine }) => (
  <SubscriptionFooterLayout className={`${hasLine ? "hasLine" : ""}`}>
    <p className="centerInfo">
      <strong>보험 상품 안내 : </strong>
      <a href="tel:1566-5800" className="underline">
        1566-5800
      </a>{" "}
      (Chubb 고객센터)
      <br />- 평일 : 09:00~18:00 (토, 일, 공휴일제외)
    </p>

    <p className="centerInfo">
      <strong>가입/변경 안내 : </strong>
      <a href="tel:1522-9657" className="underline">
        1522-9657
      </a>{" "}
      (보맵파트너 고객센터)
      <br />- 평일 : 10:00~18:00 (점심12:30~13:30), (토, 일, 공휴일제외)
    </p>
  </SubscriptionFooterLayout>
);

const SubscriptionFooterLayout = styled.div`
  padding: 30px 20px;
  padding-left: calc(env(safe-area-inset-left) + 20px);
  padding-right: calc(env(safe-area-inset-left) + 20px);
  background-color: ${props => props.theme.colors.bg};
  color: ${props => props.theme.colors.text2};

  &.hasLine {
    border-top: 1px solid ${props => props.theme.colors.divider2};
  }

  .centerInfo {
    font-size: ${props => props.theme.text.sizeFont};
    line-height: 1.67;

    & + .centerInfo {
      margin-top: 12px;
    }

    > strong,
    a {
      font-weight: ${props => props.theme.weight.bold};
    }
  }
`;

export default SubscriptionFooter;
